// Piso mínimo do frete da ANTT (Lei 13.703/2018; metodologia da Resolução
// ANTT 5.867/2020). Coeficientes da Portaria SUROC nº 22, de 28/09/2026 (DOU
// de 29/09/2026, edição extra), em vigor desde 30/09/2026, com o diesel S10 a
// R$ 7,33 o litro. A ANTT atualiza em janeiro e julho e quando o diesel varia
// muito: troque os números e a data (VIGENCIA_DO_PISO) quando sair outra.
//
// piso (R$ por viagem) = distância (km) × CCD + CC
// CCD: custo de deslocamento (R$/km) · CC: carga e descarga (R$)

export const VIGENCIA_DO_PISO = { ato: 'Portaria SUROC nº 22/2026', desde: '2026-09-30', diesel: 7.33 };

// Eixos carregados da composição (caminhão + carreta): as colunas das tabelas.
export const EIXOS = [2, 3, 4, 5, 6, 7, 9];

export const TIPOS_DE_CARGA = [
  ['granel_solido', 'Granel sólido (grãos, minério, adubo…)'],
  ['granel_liquido', 'Granel líquido (combustível, óleo, leite…)'],
  ['frigorificada', 'Frigorificada ou aquecida'],
  ['conteinerizada', 'Contêiner'],
  ['carga_geral', 'Carga geral (sacaria, caixas, paletes…)'],
  ['neogranel', 'Neogranel (bobinas, tubos, toras…)'],
  ['perigosa_granel_solido', 'Perigosa: granel sólido'],
  ['perigosa_granel_liquido', 'Perigosa: granel líquido'],
  ['perigosa_frigorificada', 'Perigosa: frigorificada ou aquecida'],
  ['perigosa_conteinerizada', 'Perigosa: contêiner'],
  ['perigosa_carga_geral', 'Perigosa: carga geral'],
  ['granel_pressurizada', 'Granel pressurizada'],
];

// A: contrata a composição (caminhão e carreta) ou o caminhão simples (o caso
// do frotista). B: só o cavalo (a carreta é de quem contrata). C e D: as
// mesmas, em operações de alto desempenho.
export const TABELAS_DO_PISO = [
  ['A', 'Caminhão e carreta (ou caminhão simples)'],
  ['B', 'Só o cavalo (a carreta é de quem contrata)'],
  ['C', 'Caminhão e carreta, alto desempenho'],
  ['D', 'Só o cavalo, alto desempenho'],
];

// [CCD, CC] por eixos (na ordem de EIXOS); null: a ANTT não tem piso para essa combinação.
const COEFICIENTES = {
  A: {
    granel_solido: [[4.1056, 460.59], [5.2555, 552.24], [5.9476, 597.00], [6.8548, 664.83], [7.5641, 680.01], [8.2316, 820.34], [9.4318, 908.91]],
    granel_liquido: [[4.1796, 471.98], [5.3511, 569.57], [6.1019, 621.52], [7.0226, 693.08], [7.7372, 709.72], [8.3700, 840.50], [9.5909, 934.76]],
    frigorificada: [[4.8234, 520.07], [6.1659, 623.27], [7.0345, 686.63], [8.0623, 757.98], [8.8911, 772.35], [9.8134, 982.76], [11.1479, 1067.06]],
    conteinerizada: [null, [5.2282, 544.75], [5.8755, 577.15], [6.7910, 647.29], [7.4986, 662.01], [8.2292, 819.69], [9.3486, 886.05]],
    carga_geral: [[4.0738, 451.84], [5.2177, 541.86], [5.9180, 588.86], [6.8284, 657.56], [7.5347, 671.93], [8.2727, 831.66], [9.4114, 903.32]],
    neogranel: [[3.6743, 451.84], [5.2162, 541.44], [5.9453, 596.35], [6.8284, 657.56], [7.5347, 671.93], [8.2727, 831.66], [9.4114, 903.32]],
    perigosa_granel_solido: [[4.8756, 608.79], [6.0354, 703.16], [6.7644, 753.03], [7.6715, 820.86], [8.3808, 836.04], [9.0666, 981.39], [10.2747, 1072.15]],
    perigosa_granel_liquido: [[4.9621, 632.58], [6.1436, 732.90], [6.8986, 789.96], [7.8193, 861.51], [8.5339, 878.16], [9.1849, 1013.95], [10.4138, 1110.41]],
    perigosa_frigorificada: [[5.4315, 630.88], [6.7869, 737.63], [7.6718, 807.63], [8.6996, 878.98], [9.5284, 893.35], [10.4745, 1110.28], [11.8192, 1197.43]],
    perigosa_conteinerizada: [null, [5.6126, 645.45], [6.2966, 682.95], [7.2121, 753.10], [7.9198, 767.81], [8.6686, 930.51], [9.7960, 999.06]],
    perigosa_carga_geral: [[4.4482, 549.81], [5.6021, 642.55], [6.3392, 694.66], [7.2495, 763.36], [7.9558, 777.73], [8.7121, 942.48], [9.8588, 1016.33]],
    granel_pressurizada: [null, null, null, [7.1929, 757.81], [7.9452, 784.82], null, [9.9531, 1052.26]],
  },
  B: {
    granel_solido: [null, null, [5.3538, 533.40], [6.0900, 594.62], [6.7863, 608.99], [7.2181, 720.31], [8.0379, 773.22]],
    granel_liquido: [null, null, [5.4189, 533.40], [6.1551, 594.62], [6.8514, 608.99], [7.2832, 720.31], [8.1030, 773.22]],
    frigorificada: [null, null, [6.2988, 584.04], [7.1428, 645.26], [7.9617, 659.62], [8.4117, 775.96], [9.3892, 831.06]],
    conteinerizada: [null, null, [5.3538, 533.40], [6.0900, 594.62], [6.7863, 608.99], [7.2181, 720.31], [8.0379, 773.22]],
    carga_geral: [null, null, [5.3538, 533.40], [6.0900, 594.62], [6.7863, 608.99], [7.2181, 720.31], [8.0379, 773.22]],
    neogranel: [null, null, [5.3538, 533.40], [6.0900, 594.62], [6.7863, 608.99], [7.2181, 720.31], [8.0379, 773.22]],
    perigosa_granel_solido: [null, null, [6.1705, 689.44], [6.9067, 750.65], [7.6030, 765.02], [8.0530, 881.36], [8.8808, 936.46]],
    perigosa_granel_liquido: [null, null, [6.2156, 701.84], [6.9518, 763.06], [7.6481, 777.43], [8.0981, 893.76], [8.9259, 948.87]],
    perigosa_frigorificada: [null, null, [6.9361, 705.04], [7.7801, 766.25], [8.5990, 780.62], [9.0727, 903.48], [10.0606, 961.43]],
    perigosa_conteinerizada: [null, null, [5.7749, 639.21], [6.5111, 700.42], [7.2074, 714.79], [7.6574, 831.13], [8.4853, 886.23]],
    perigosa_carga_geral: [null, null, [5.7749, 639.21], [6.5111, 700.42], [7.2074, 714.79], [7.6574, 831.13], [8.4853, 886.23]],
    granel_pressurizada: [null, null, null, [6.0900, 594.62], [6.7863, 608.99], null, [8.0379, 773.22]],
  },
  C: {
    granel_solido: [[3.4876, 174.38], [4.4476, 198.05], [5.0799, 215.03], [5.8290, 229.64], [6.5029, 232.91], [6.8871, 270.36], [7.8999, 292.59]],
    granel_liquido: [[3.5350, 176.84], [4.5028, 201.78], [5.1771, 220.31], [5.9310, 235.73], [6.6068, 239.32], [6.9785, 274.70], [7.9988, 298.16]],
    frigorificada: [[4.1786, 205.65], [5.3115, 232.97], [6.0901, 256.16], [6.9516, 271.54], [7.7470, 274.63], [8.2358, 329.34], [9.3985, 351.60]],
    conteinerizada: [null, [4.4378, 196.43], [5.0540, 210.75], [5.8061, 225.87], [6.4794, 229.04], [6.8862, 270.22], [7.8701, 287.67]],
    carga_geral: [[3.4762, 172.50], [4.4341, 195.81], [5.0693, 213.27], [5.8195, 228.08], [6.4924, 231.17], [6.9018, 272.80], [7.8926, 291.39]],
    neogranel: [[3.0767, 172.50], [4.4335, 195.72], [5.0791, 214.89], [5.8195, 228.08], [6.4924, 231.17], [6.9018, 272.80], [7.8926, 291.39]],
    perigosa_granel_solido: [[4.0241, 224.77], [4.9948, 250.19], [5.6653, 270.47], [6.4144, 285.09], [7.0883, 288.36], [7.4921, 329.05], [8.5135, 352.70]],
    perigosa_granel_liquido: [[4.0551, 229.89], [5.0336, 256.60], [5.7135, 278.43], [6.4674, 293.85], [7.1433, 297.43], [7.5346, 336.06], [8.5635, 360.94]],
    perigosa_frigorificada: [[4.6738, 253.51], [5.8205, 283.12], [6.6174, 310.60], [7.4789, 325.98], [8.2743, 329.07], [8.7886, 388.00], [9.9625, 412.10]],
    perigosa_conteinerizada: [null, [4.7065, 237.75], [5.3608, 255.37], [6.1129, 270.49], [6.7862, 273.66], [7.2127, 318.08], [8.2051, 336.95]],
    perigosa_carga_geral: [[3.7341, 212.06], [4.7027, 237.13], [5.3761, 257.89], [6.1263, 272.70], [6.7992, 275.79], [7.2283, 320.66], [8.2277, 340.67]],
    granel_pressurizada: [null, null, null, [5.9504, 249.68], [6.6398, 255.50], null, [8.0871, 323.48]],
  },
  D: {
    granel_solido: [null, null, [4.6343, 201.32], [5.2278, 214.52], [5.8907, 217.61], [6.1067, 248.80], [6.8223, 263.35]],
    granel_liquido: [null, null, [4.6994, 201.32], [5.2929, 214.52], [5.9558, 217.61], [6.1718, 248.80], [6.8874, 263.35]],
    frigorificada: [null, null, [5.5936, 234.06], [6.2949, 247.25], [7.0803, 250.34], [7.3160, 284.78], [8.1899, 300.75]],
    conteinerizada: [null, null, [4.6343, 201.32], [5.2278, 214.52], [5.8907, 217.61], [6.1067, 248.80], [6.8223, 263.35]],
    carga_geral: [null, null, [4.6343, 201.32], [5.2278, 214.52], [5.8907, 217.61], [6.1067, 248.80], [6.8223, 263.35]],
    neogranel: [null, null, [4.6343, 201.32], [5.2278, 214.52], [5.8907, 217.61], [6.1067, 248.80], [6.8223, 263.35]],
    perigosa_granel_solido: [null, null, [5.2197, 256.77], [5.8131, 269.96], [6.4760, 273.05], [6.7117, 307.49], [7.4359, 323.46]],
    perigosa_granel_liquido: [null, null, [5.2359, 259.44], [5.8293, 272.63], [6.4922, 275.73], [6.7279, 310.16], [7.4521, 326.13]],
    perigosa_frigorificada: [null, null, [6.1208, 288.50], [6.8222, 301.69], [7.6076, 304.78], [7.8688, 343.44], [8.7539, 361.25]],
    perigosa_conteinerizada: [null, null, [4.9411, 245.95], [5.5346, 259.14], [6.1975, 262.23], [6.4332, 296.67], [7.1574, 312.64]],
    perigosa_carga_geral: [null, null, [4.9411, 245.95], [5.5346, 259.14], [6.1975, 262.23], [6.4332, 296.67], [7.1574, 312.64]],
    granel_pressurizada: [null, null, null, [5.2278, 214.52], [5.8907, 217.61], null, [6.8223, 263.35]],
  },
};

// Os coeficientes de uma combinação, ou null se ela não existe na tabela.
export function coeficientes({ tabela = 'A', tipo, eixos }) {
  const linha = COEFICIENTES[tabela]?.[tipo];
  const i = EIXOS.indexOf(Number(eixos));
  if (!linha || i < 0 || !linha[i]) return null;
  const [ccd, cc] = linha[i];
  return { ccd, cc };
}

// O piso da viagem (só ida, carregado), em reais, ou null se não há piso para a combinação.
export function pisoMinimo({ tabela = 'A', tipo, eixos, km }) {
  const c = coeficientes({ tabela, tipo, eixos });
  const distancia = Number(km);
  if (!c || !Number.isFinite(distancia) || distancia <= 0) return null;
  return Math.round((distancia * c.ccd + c.cc) * 100) / 100;
}

// Eixos que têm piso para um tipo de carga numa tabela.
export function eixosComPiso({ tabela = 'A', tipo }) {
  return EIXOS.filter((e) => coeficientes({ tabela, tipo, eixos: e }));
}
